import type {MouseEventHandler, ReactElement} from 'react';
import {IconSize} from '@Components/icon-v2/icon.types';
import {Button, ButtonType, ButtonSize} from '@Components/button';

export interface PanelHeaderActionProps {
  key?: string;
  text?: string;
  icon?: string;
  className?: string;
  iconSize?: IconSize;
  onClick?: MouseEventHandler;
  title?: string;
  type?: ButtonType;
  titleClassName?: string;
}

export function PanelHeaderAction({
  title = '',
  text = '',
  className = '',
  icon = '',
  iconSize = IconSize.SIZE_ICON_20,
  type = ButtonType.TERTIARY,
  ...props
}: PanelHeaderActionProps): ReactElement<any> {
  const getSizeFromIconSize = (): ButtonSize => {
    switch (iconSize) {
      case IconSize.SIZE_ICON_16:
        return ButtonSize.SMALL;
      case IconSize.SIZE_ICON_20:
        return ButtonSize.LARGE;
      case IconSize.SIZE_ICON_24:
        return ButtonSize.EXTRA_LARGE;
      default:
        return ButtonSize.LARGE;
    }
  };

  return (
    <Button
      key={props.key}
      text={text}
      size={getSizeFromIconSize()}
      icon={icon}
      title={title}
      customClasses={className}
      onClick={props.onClick}
      type={type}
      textClasses={props.titleClassName}
    />
  );
}
